import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { alpha } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import OmniAvatar from "./omniAvatar";

const WidgetTitle = props => {
  const { title = "", text = null, menu = null, loading = false, avatar = null } = props;

  const theme = useTheme();

  return (
    <Box
      sx={{
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: 0,
        display: "flex",
        flexDirection: "row",
        userSelect: "none",
        webkitUserSelect: "none",
        position: "relative",
        borderBottom: `1px solid ${alpha(theme.palette.commonground.contrastText, 0.25)}`,
      }}
    >
      {avatar && (
        <OmniAvatar
          src={avatar}
          sx={
            {
              // marginTop: theme.spacing(0.5),
              // marginLeft: theme.spacing(-0.5),
              // marginRight: theme.spacing(1.5),
            }
          }
        />
      )}
      {menu && (
        <Box
          sx={{
            flexDirection: "row",
            padding: theme.spacing(0.5),
          }}
        >
          {menu}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          marginTop: theme.spacing(0.5),
        }}
      >
        {text != null && (
          <Typography variant="overline" sx={{ color: theme.palette.commonground.contrastText }}>
            {title}
          </Typography>
        )}
        {text != null && (
          <Typography
            variant="h5"
            sx={{
              whiteSpace: "nowrap",
              width: "100%",
              marginTop: `-${theme.spacing(1.5)}`,
              marginBottom: `${theme.spacing(0.5)}`,
            }}
          >
            {loading ? <Skeleton variant="text" /> : text}
          </Typography>
        )}
        {text == null && (
          <Typography variant="h3" sx={{ width: "100%" }}>
            {title}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          flexGrow: 0,
          flexShrink: 1,
          marginTop: theme.spacing(1.5),
          marginLeft: theme.spacing(2),
          alignItems: "bottom", // Centers content vertically
          justifyContent: "bottom", // Centers content horizontally (optional)
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export default WidgetTitle;
